import type { BillStatus } from '../data/types';

export type ReconcileStepId = 'import' | 'match' | 'sync' | 'approve';

export const RECONCILE_STEPS: Array<{ id: ReconcileStepId; label: string; short: string }> = [
  { id: 'import', label: 'Import invoice', short: 'Import' },
  { id: 'match', label: 'Match to PO', short: 'Match' },
  { id: 'sync', label: 'Sync receipt', short: 'Sync' },
  { id: 'approve', label: 'Approve', short: 'Approve' },
];

export function resolveReconcileStep(ctx: {
  processed: boolean;
  billImported: boolean;
  linkedPoId?: string | null;
  backfillApplied: boolean;
  status: BillStatus;
}): ReconcileStepId {
  if (!ctx.processed && !ctx.billImported) return 'import';
  if (ctx.linkedPoId && ctx.processed && !ctx.backfillApplied) return 'sync';
  if (ctx.processed && ['Draft', 'Awaiting approval'].includes(ctx.status)) {
    return 'approve';
  }
  if (ctx.processed) return 'match';
  return 'import';
}

export function reconcileStepIndex(step: ReconcileStepId): number {
  return RECONCILE_STEPS.findIndex(s => s.id === step);
}

export function reconcileNextAction(step: ReconcileStepId, status: BillStatus): string {
  if (step === 'import') return 'Drop the supplier invoice in the panel on the left.';
  if (step === 'match') return 'Check each line against the PO — resolve any variances.';
  if (step === 'sync') return 'Sync matched lines to the linked PO when ready.';
  if (status === 'Awaiting approval') return 'Review totals and approve for payment.';
  if (status === 'Approved') return 'Export to accounting or mark as paid.';
  if (status === 'Paid') return 'Closed — nothing more to do here.';
  return 'Review totals and approve for payment.';
}
